import { render, staticRenderFns } from "./castinglist.vue?vue&type=template&id=5ed68a98&"
import script from "./castinglist.vue?vue&type=script&lang=js&"
export * from "./castinglist.vue?vue&type=script&lang=js&"
import style0 from "./castinglist.vue?vue&type=style&index=0&id=5ed68a98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports